<template>
  <router-link
    class="notification-icon"
    title="Показать уведомления"
    v-bind:to="{ name: 'ClinicPanelNotificationList', query: { page: 1 } }"
  >
    <div
      class="notification-icon__new"
      v-if="newNotificationCount > 0"
    />
  </router-link>
</template>

<script>
export default {
  name: 'NotificationIcon',
  computed: {
    newNotificationCount() {
      return this.$store.getters.getNewNotificationCount;
    },
  },
};
</script>

<style scoped lang="scss">
.notification-icon {
  position: relative;
  display: flex;
  &:before {
    content: "";
    background-image: url("@/assets/img/notifications-grey.svg");
    background-repeat: no-repeat;
    background-size: contain;
    width: 19px;
    height: 23px;
  }
  &:hover::before {
    background-image: url("@/assets/img/notifications-blue.svg");
  }
  &__new {
    position: absolute;
    bottom: 0px;
    right: 0px;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: #f3554c;
  }
}
</style>
